import {
    ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector,
} from '@angular/core';
import { SnackbarComponent } from '../components/shared/snackbar/snackbar.component';

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    private componentRef?: ComponentRef<SnackbarComponent>;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector,
        private appRef: ApplicationRef,
    ) {}

    private createComponent(message: string, type: 'success' | 'warning', duration: number): void {
        // Create component factory for TpSnackbarComponent
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SnackbarComponent);

        // Create the component dynamically
        this.componentRef = componentFactory.create(this.injector);

        // Pass the message, type, and duration to the component instance
        this.componentRef.instance.message = message;
        this.componentRef.instance.type = type;
        this.componentRef.instance.duration = duration;

        // Attach the component to the Angular app's view
        this.appRef.attachView(this.componentRef.hostView);

        // Append the component's DOM element to the body (or wherever you want it to be rendered)
        const domElem = (this.componentRef.hostView as any).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);

        // Open the snackbar
        this.componentRef.instance.open();

        // Auto-detach and clean up after the snackbar's duration ends
        if (duration !== -1) {
            setTimeout(() => this.destroyComponent(), duration);
        }
    }

    /**
     * Show success snackbar
     */
    success(message: string, duration = 3000): void {
        this.createComponent(message, 'success', duration);
    }

    /**
     * Show error/warning snackbar
     */
    error(message: string, duration = -1): void {
        this.createComponent(message, 'warning', duration);
    }

    /**
     * Destroy and clean up the snackbar component
     */
    private destroyComponent(): void {
        if (this.componentRef) {
            this.appRef.detachView(this.componentRef.hostView);
            this.componentRef.destroy();
        }
    }
}
